import React from 'react';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { Badge } from '../components/ui/badge';

export default function FAQ() {
  const faqs = [
    { q: 'Trendyol API anahtarlarımı nasıl alırım?', a: 'Trendyol Satıcı Paneli\'nden API ayarlarına giderek Seller ID, API Key ve API Secret bilgilerinizi alabilirsiniz.' },
    { q: 'Hibrit mod nedir?', a: 'Hibrit modda AI tarafından oluşturulan yanıtlar size gösterilir. Onaylandıktan sonra gönderilir. Tam kontrol sizde olur.' },
    { q: 'Full-Auto mod güvenli mi?', a: 'Evet! AI modelimiz ürün bilgilerine dayanarak yanıt verir. Özel promptlar ile markanıza özel ton yakalayabilirsiniz.' },
    { q: 'Ücretsiz deneme nasıl çalışır?', a: 'Kaydınızı tamamladıktan sonra 10 soru hakkıyla başlarsınız. Bu sürede platformu test edebilirsiniz.' },
    { q: 'Hangi e-ticaret platformlarını destekliyorsunuz?', a: 'Şu anda Trendyol ve Hepsiburada desteklenmektedir. Yakında daha fazla platform eklenecek.' },
    { q: 'AI yanıtları ne kadar doğru?', a: 'AI modelimiz ürün bilgilerinize dayanarak %95+ doğruluk oranıyla yanıt verir.' },
    { q: 'Mağaza değiştirme limiti var mı?', a: 'Hayır, plan limitiniz dahilinde istediğiniz kadar mağaza ekleyip çıkarabilirsiniz.' },
    { q: 'Destek nasıl alırım?', a: 'Email, chat ve telefon desteği sunuyoruz. Plan seviyenize göre destek kanalları değişir.' }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <PublicHeader />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <Badge className="mb-4 bg-orange-100 text-[#FF6000] hover:bg-orange-100">SSS</Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Sıkça Sorulan Sorular</h1>
          <p className="text-xl text-gray-600">Merak ettiklerinizin cevapları burada</p>
        </div>
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`} className="bg-white border rounded-lg px-6">
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-[#FF6000]">{faq.q}</AccordionTrigger>
              <AccordionContent className="text-gray-600">{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">Cevap bulamadınız mı?</p>
          <button onClick={() => window.location.href = '/contact'} className="bg-[#FF6000] hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold">İletişime Geçin</button>
        </div>
      </div>
      <Footer />
    </div>
  );
}
